(function(){
  /* ── Delivery ETA Countdown ── */
  window.DIYInitHeaderETA = function(eta) {
  if (!eta) return;
  if (eta._etaCleanup) eta._etaCleanup();

  var prodDays = (eta.dataset.productionDays || '').split(',').filter(Boolean).map(Number);
  var cutoff = eta.dataset.cutoffTime || '13:00';
  var prodTime = parseInt(eta.dataset.productionTime) || 0;
  var defaultShipDays = parseInt(eta.dataset.defaultShippingDays) || 2;
  var tz = eta.dataset.timezone || 'America/New_York';
  var holidays = (eta.dataset.holidays || '').split(',').map(function(d){ return d.trim(); }).filter(Boolean);
  var tpl = eta.dataset.template || 'Fastest Delivery [Date] if ordered in:';
  var fallbackTpl = eta.dataset.fallbackTemplate || 'Next Day Production + Shipped';

  /* Parse transit map */
  var transitMap = {};
  var stateList = [];
  (eta.dataset.transitMap || '').split(',').forEach(function(pair) {
    var parts = pair.trim().split(':');
    if (parts.length === 2) {
      var st = parts[0].trim().toUpperCase();
      transitMap[st] = parseInt(parts[1].trim());
      stateList.push(st);
    }
  });

  /* ── State: default FL, then upgrade from cache/customer ── */
  var currentState = 'FL';
  var shipDays = transitMap['FL'] || defaultShipDays;

  function setState(code) {
    if (!code) return;
    code = code.toUpperCase().trim();
    if (!transitMap[code]) return;
    currentState = code;
    shipDays = transitMap[code];
    try { localStorage.setItem('diyprintz_eta_state', code); } catch(e) {}
    update();
    /* Update picker display */
    var lbl = eta.querySelector('[data-eta-state-label]');
    if (lbl) lbl.textContent = code;
  }

  /* Restore saved state (localStorage persists across sessions) */
  try {
    var saved = localStorage.getItem('diyprintz_eta_state');
    if (saved && transitMap[saved.toUpperCase()]) {
      currentState = saved.toUpperCase();
      shipDays = transitMap[currentState];
    }
  } catch(e) {}

  /* Override with logged-in customer address if available */
  var customerState = (eta.dataset.customerState || '').trim().toUpperCase();
  if (customerState && transitMap[customerState]) {
    currentState = customerState;
    shipDays = transitMap[currentState];
  }

  /* ── Build state picker (only if customer has no address on file) ── */
  var addressStatus = (eta.dataset.customerHasAddress || 'guest').trim();
  /* true = logged in with address, false = logged in no address, guest = not logged in */
  var showPicker = addressStatus !== 'true';

  if (showPicker) {
    /* Location pin button — placed AFTER the countdown as its own column */
    var pickerWrap = document.createElement('div');
    pickerWrap.className = 'catmenu__eta-picker';
    pickerWrap.innerHTML = '<button type="button" data-eta-state-btn class="catmenu__eta-state-btn">'
      + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.87 117.55"><path fill-rule="evenodd" d="M78.81,82.78c-4.35,4.77-9.42,9.05-15.12,12.51-.7.51-1.65.58-2.43.08-8.41-5.35-15.48-11.78-21.03-18.76-7.66-9.61-12.49-20.27-14.14-30.53-1.68-10.41-.11-20.42,5.07-28.56,2.04-3.22,4.65-6.15,7.83-8.68C46.3,3.01,54.65-.06,62.96,0c8.01.06,15.91,3.05,22.74,9.28,2.4,2.18,4.42,4.68,6.07,7.39,5.57,9.17,6.77,20.87,4.32,32.73-2.41,11.71-8.41,23.62-17.28,33.35v.03h0ZM25.32,74.54c1.98,0,3.59,1.61,3.59,3.59s-1.61,3.59-3.59,3.59h-6.74l-8.88,28.67h103.22l-9.64-28.67h-5.57c-1.98,0-3.59-1.61-3.59-3.59s1.61-3.59,3.59-3.59h10.7l14.46,43.01H0l13.32-43.01h12ZM61.38,18.51c9.88,0,17.88,8.01,17.88,17.87s-8.01,17.88-17.88,17.88-17.87-8-17.87-17.88c-.02-9.87,7.99-17.87,17.87-17.87h0Z"/></svg>'
      + '<span data-eta-state-label>' + currentState + '</span></button>';
    var countdownInsert = eta.querySelector('[data-eta-countdown]');
    if (countdownInsert && countdownInsert.parentNode) {
      countdownInsert.parentNode.insertBefore(pickerWrap, countdownInsert.nextSibling);
    }

    /* Build modal */
    var stateNames = {AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DC:'Washington DC',DE:'Delaware',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming'};

    var overlay = document.createElement('div');
    overlay.className = 'catmenu__modal-overlay';
    var options = stateList.sort().map(function(st) {
      var name = stateNames[st] || st;
      return '<option value="' + st + '"' + (st === currentState ? ' selected' : '') + '>' + name + '</option>';
    }).join('');
    overlay.innerHTML = '<div class="catmenu__modal">'
      + '<button type="button" class="catmenu__modal-close">&times;</button>'
      + '<div class="catmenu__modal-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.87 117.55" width="36" height="36"><path fill="#ff5b00" fill-rule="evenodd" d="M78.81,82.78c-4.35,4.77-9.42,9.05-15.12,12.51-.7.51-1.65.58-2.43.08-8.41-5.35-15.48-11.78-21.03-18.76-7.66-9.61-12.49-20.27-14.14-30.53-1.68-10.41-.11-20.42,5.07-28.56,2.04-3.22,4.65-6.15,7.83-8.68C46.3,3.01,54.65-.06,62.96,0c8.01.06,15.91,3.05,22.74,9.28,2.4,2.18,4.42,4.68,6.07,7.39,5.57,9.17,6.77,20.87,4.32,32.73-2.41,11.71-8.41,23.62-17.28,33.35v.03h0ZM25.32,74.54c1.98,0,3.59,1.61,3.59,3.59s-1.61,3.59-3.59,3.59h-6.74l-8.88,28.67h103.22l-9.64-28.67h-5.57c-1.98,0-3.59-1.61-3.59-3.59s1.61-3.59,3.59-3.59h10.7l14.46,43.01H0l13.32-43.01h12ZM61.38,18.51c9.88,0,17.88,8.01,17.88,17.87s-8.01,17.88-17.88,17.88-17.87-8-17.87-17.88c-.02-9.87,7.99-17.87,17.87-17.87h0Z"/></svg></div>'
      + '<h3 class="catmenu__modal-title">Get Your Delivery Estimate</h3>'
      + '<p class="catmenu__modal-desc">Select your state to see the fastest delivery date for your location.</p>'
      + '<select class="catmenu__modal-select" data-eta-modal-select>' + options + '</select>'
      + '<button type="button" class="catmenu__modal-confirm" data-eta-modal-confirm>Update My Location</button>'
      + '</div>';
    document.body.appendChild(overlay);

    /* Open modal */
    var stateBtn = pickerWrap.querySelector('[data-eta-state-btn]');
    stateBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      overlay.classList.add('open');
    });

    /* Close modal */
    overlay.querySelector('.catmenu__modal-close').addEventListener('click', function() {
      overlay.classList.remove('open');
    });
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) overlay.classList.remove('open');
    });

    /* Confirm selection */
    overlay.querySelector('[data-eta-modal-confirm]').addEventListener('click', function() {
      var sel = overlay.querySelector('[data-eta-modal-select]');
      setState(sel.value);
      overlay.classList.remove('open');
    });
  }

  /* ── Core functions ── */
  var textEl = eta.querySelector('[data-eta-text]');
  var hoursEl = eta.querySelector('[data-eta-hours]');
  var minsEl = eta.querySelector('[data-eta-minutes]');
  var secsEl = eta.querySelector('[data-eta-seconds]');
  var countdownEl = eta.querySelector('[data-eta-countdown]');

  function getNow() {
    return window.DIYCalendarCore.wallNow(tz);
  }
  function isHoliday(d) {
    var s1 = (d.getMonth()+1)+'/'+d.getDate()+'/'+d.getFullYear();
    var s2 = (d.getMonth()+1)+'/'+d.getDate();
    return holidays.indexOf(s1) !== -1 || holidays.indexOf(s2) !== -1;
  }
  var shopClosures = window.DIYCalendarCore.create(eta.dataset.productionClosures || '');
  function isProdDay(d) { return prodDays.indexOf(d.getDay()) !== -1 && !isHoliday(d) && !shopClosures.isClosed(window.DIYCalendarCore.key(d)); }
  function isUpsDay(d) { var day = d.getDay(); return day >= 1 && day <= 5 && !isHoliday(d); }
  function nextUpsDay(d) { var r = new Date(d); while (!isUpsDay(r)) r.setDate(r.getDate()+1); return r; }
  function addUpsTransitDays(start, count) { var d = new Date(start), added = 0; while (added < count) { d.setDate(d.getDate()+1); if (isUpsDay(d)) added++; } return d; }
  function addProdDays(start, count) { var d = new Date(start), added = 0; while (added < count) { d.setDate(d.getDate()+1); if (isProdDay(d)) added++; } return d; }
  function getDeliveryDate(prodCompleteDate, transitDays) { return addUpsTransitDays(nextUpsDay(prodCompleteDate), transitDays); }
  function fmtDate(d) {
    var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return days[d.getDay()]+', '+months[d.getMonth()]+'. '+d.getDate();
  }
  function pad(n) { return n < 10 ? '0'+n : ''+n; }

  function update() {
    if (!eta.isConnected) { if (eta._etaCleanup) eta._etaCleanup(); return; }
    if (!prodDays.length) {
      textEl.textContent = 'Contact us for a production estimate';
      countdownEl.style.display = 'none';
      return;
    }
    var now = getNow();
    var parts = cutoff.split(':');
    var cutH = parseInt(parts[0]), cutM = parseInt(parts[1]||0);
    var cutoffToday = new Date(now); cutoffToday.setHours(cutH, cutM, 0, 0);
    var beforeCutoff = now < cutoffToday && isProdDay(now);

    if (beforeCutoff) {
      var diff = cutoffToday - now;
      hoursEl.textContent = pad(Math.floor(diff/3600000));
      minsEl.textContent = pad(Math.floor((diff%3600000)/60000));
      secsEl.textContent = pad(Math.floor((diff%60000)/1000));
      var prodComplete = prodTime > 0 ? addProdDays(now, prodTime) : now;
      var delDate = getDeliveryDate(prodComplete, shipDays);
      var loc = ' to ' + currentState;
      var msg = tpl.replace('[Date]','<strong>'+fmtDate(delDate)+'</strong>').replace('[Location]', loc).replace('[Time]','');
      /* Mobile: duplicate for marquee loop. Desktop: single. */
      if (window.innerWidth < 990) {
        var sep = ' &nbsp;★&nbsp; ';
        textEl.innerHTML = msg + sep + msg + sep;
      } else {
        textEl.innerHTML = msg;
      }
      countdownEl.style.display = '';
    } else {
      var nextProd = new Date(now);
      nextProd.setDate(nextProd.getDate()+1);
      var attempts = 0;
      while (!isProdDay(nextProd) && attempts++ < 3660) nextProd.setDate(nextProd.getDate()+1);
      if (!isProdDay(nextProd)) {
        textEl.textContent = 'Contact us for a production estimate';
        countdownEl.style.display = 'none';
        return;
      }
      var prodComplete = prodTime > 0 ? addProdDays(nextProd, prodTime) : nextProd;
      var delDate = getDeliveryDate(prodComplete, shipDays);
      var loc = ' to ' + currentState;
      var msg = fallbackTpl.replace('[Date]','<strong>'+fmtDate(delDate)+'</strong>').replace('[Location]', loc).replace('[Time]','');
      if (window.innerWidth < 990) {
        var sep = ' &nbsp;★&nbsp; ';
        textEl.innerHTML = msg + sep + msg + sep;
      } else {
        textEl.innerHTML = msg;
      }
      countdownEl.style.display = 'none';
    }
  }

  /* Run immediately — no waiting for anything */
  update();
  var etaTimer = setInterval(update, 1000);
  eta._etaCleanup = function() {
    clearInterval(etaTimer);
    if (overlay) overlay.remove();
    if (pickerWrap) pickerWrap.remove();
  };
  };
  document.querySelectorAll('[data-eta-block]').forEach(window.DIYInitHeaderETA);
})();
